import { useParams } from 'react-router-dom'
import {KTSVG} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';

type LocationState = {
  partyId?: string
}
const PartyEditModalHeader = ({isPage = false}) => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  // const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation()
  const state = location.state as LocationState
  const id = state?.partyId
  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>{id ? 'Edit Party' : 'Add Party'}</h2>
      {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
      <button onClick={() => navigate(-1)} className="btn btn-secondary">
        ← Back
      </button>
    </div> */}
    
      {!isPage && (
        <div
          className='btn btn-icon btn-sm btn-active-icon-primary'
          data-kt-servicecenters-modal-action='close'
          onClick={() => setItemIdForUpdate(undefined)}
          style={{cursor: 'pointer'}}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
        </div>
      )}
      {/* <div
        className='btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary bg-white h-30px w-30px position-absolute start-100 translate-middle'
        style={{zIndex: 99, top: '33px',marginLeft: '-34px'}}
        onClick={() => navigate(-1)}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr025.svg' className='svg-icon-2' />
      </div> */}
      <div
        className="btn btn-icon btn-shadow-lg  bg-primary text-white position-absolute start-100 translate-middle d-flex align-items-center justify-content-center border border-light"
        style={{ zIndex: 99, top: "33px", marginLeft: "-34px" ,width: "34px",
          height: "32px"}}
        role="button"
        aria-label="Go back to previous page"
        tabIndex={0}
        data-tooltip="Back"
        onClick={() => navigate(-1)}
      >
        <KTSVG path="/media/icons/duotune/arrows/arr025.svg" className="svg-icon-4 text-white" />
      </div>
    </div>
  )
}

export {PartyEditModalHeader}
